import { useAmenities } from "./Amenities.hook";
import { CSSProperties, useContext, useState } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import React from "react";
import "./styles.less"
import { ArrowIcon } from "shared-components/Components/CustomIcons/ArrowIcon/web";
import { BoxesContainer } from "../BoxesContainer/web";
import { AmenitiesModal } from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/AmenitiesModal/web";

interface AmenitiesProps {
    openByDefault?: boolean;
    style?: CSSProperties;
    changeFilters: (filters: any) => void;
    filters: any;
    filtersTags: any;
    show?: boolean;
    triggerApplyFilter?: (values: any) => void;
}

export const Amenities = ({ openByDefault, style={}, changeFilters, filters, filtersTags, show = false,triggerApplyFilter = undefined } : AmenitiesProps) => {
    if (!show) return null;
    
    const { country_code } = useContext(ConfigStateContext);
    const {
        amenitiesToShow,
        showMore,
        handleSelect,
        isActive,
        showComponent
    } = useAmenities({
        country_code,
        openByDefault,
        filters,
        filtersTags,
        changeFilters,
        triggerApplyFilter
    });
    const [showModalAmenities, setShowModalAmenities] = useState(false);

    const handleShowMore = () => {
        if (country_code === "CO") setShowModalAmenities(true)
        else showMore.set(!showMore.value)
    }

    return showComponent && amenitiesToShow?.main?.length > 0 ? (
        <div className="filter amenities-filter" style={style}>
            <h3 className="filter-title">Extras</h3>

            <AmenitiesModal
                show={showModalAmenities}
                setShow={setShowModalAmenities}
            />

            <BoxesContainer
                options={amenitiesToShow.main}
                selectedValues={filters?.facilitiesGroup || []}
                isItemActive={(amenity) => isActive(amenity.id)}
                onItemClick={(amenity) => handleSelect(amenity)}
            />

            {showMore.value && amenitiesToShow.extra.map((option, index) => (
                <div
                    key={`amenity-group-${index}`}
                    className={`${!option.group ? "without-title" : ""}`}
                >
                   {option.group ? <h3 className="amenities-filter__subtitle">{option.group}</h3> : null}

                    <BoxesContainer
                        options={option.amenities}
                        selectedValues={filters?.facilitiesGroup || []}
                        isItemActive={(amenity) => isActive(amenity.id)}
                        onItemClick={(amenity) => handleSelect(amenity)}
                    />
                </div>
                )
            )}
            
            <div className="show-more__container">
                <button
                    onClick={handleShowMore}
                    className="show-more__button"
                >
                    <span>{showMore.value ? 'Ver menos' : 'Ver más'}</span>
                    {showMore.value ? <ArrowIcon type="top" /> : <ArrowIcon type="bottom" />}
                </button>
            </div>

            <hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
        </div>
    ):<></>
}